import { Component, OnInit, ViewChild } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { Applicants } from '../applicants/Applicants';
import { AllApplicantsService } from '../applicants/applicants.service';
import { Router } from '@angular/router';
import { AcademicYear } from '../applicants/AcademicYear';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UrlSignature } from '../common/apiEndpoint';
import { DomSanitizer } from '@angular/platform-browser';
import { ReportService } from './reports.service';
import { MatAccordion } from '@angular/material/expansion';
import { DashboardService } from '../dashboard/dashboard.service';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss'],
})
export class ReportsComponent implements OnInit {
  @ViewChild(MatAccordion) accordion: MatAccordion;
  panelOpenState = false;

  displayedColumns: string[] = [
    'id',
    'ReportName',
    'ApplicantsNumber',
    'ReportAction',
  ];
  dataSource = [];
  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(
      map((result) => result.matches),
      shareReplay(),
    );

  applicants: Applicants[];
  certificateApplicants: Applicants[];
  degreeApplicants: Applicants[];
  diplomaApplicants: Applicants[];
  totalApplicants: number;
  totalCertificateApplicants: number;
  totalDegreeApplicants: number;
  totalDiplomaApplicants: number;
  years: AcademicYear[];
  year: string;
  waitlistedApplicants: number;
  acceptedApplicants: number;
  rejectedApplicants: number;
  allApplicantExcelFileUrl: string;
  degreeApplicantsExcelUrl: string;
  diplomaApplicantsExcelUrl: string;
  certificateApplicantsExcelUrl: string;
  rejectedApplicantsExcelUrl: string;
  acceptedApplicantsExcelUrl: string;
  waitlistedApplicantsExcelUrl: string;
  ghanaianApplicants: number;
  nonGhanaianApplicants: number;
  maleApplicants: number;
  femaleApplicants: number;
  degreeGhanaianApplicants: number;
  degreeNonGhanaianApplicants: number;
  degreeMaleApplicants: number;
  degreeFemaleApplicants: number;
  diplomaGhanaianApplicants: number;
  diplomaNonGhanaianApplicants: number;
  diplomaMaleApplicants: number;
  diplomaFemaleApplicants: number;
  certificateGhanaianApplicants: number;
  certificateNonGhanaianApplicants: number;
  certificateMaleApplicants: number;
  certificateFemaleApplicants: number;
  acceptedGhanaianApplicants: number;
  acceptedNonGhanaianApplicants: number;
  acceptedMaleApplicants: number;
  acceptedFemaleApplicants: number;
  waitlistedGhanaianApplicants: number;
  waitlistedNonGhanaianApplicants: number;
  waitlistedMaleApplicants: number;
  waitlistedFemaleApplicants: number;
  rejectedGhanaianApplicants: number;
  rejectedNonGhanaianApplicants: number;
  rejectedMaleApplicants: number;
  rejectedFemaleApplicants: number;
  public loading = false;

  constructor(
    private router: Router,
    private breakpointObserver: BreakpointObserver,
    private allApplicantsService: AllApplicantsService,
    private urlSignature: UrlSignature,
    private reportService: ReportService,
  ) {}

  ngOnInit() {
    this.loading = true;
    this.allApplicantsService.getCurrentYear().subscribe((currentYear) => {
      console.log(currentYear.response);
      this.allApplicantsService.getAcademicYears().subscribe((response) => {
        this.years = response;
        console.log('years: ', this.years);
        this.year = currentYear.response;
        this.allApplicantsService
          .getAllApplicants(this.year)
          .subscribe((applicants) => {
            this.applicants = applicants;
            this.dataSource = this.applicants;
            setTimeout(()=>{
              this.populateApplicantsNo();
                this.loading = false;
            }, 3000)
          });
      });
    });
  }

  private populateApplicantsNo() {
    this.totalApplicants = this.applicants.length;
    this.ghanaianApplicants = this.applicants.filter(
      (applicant) => applicant.country === 'Ghana',
    ).length;
    this.nonGhanaianApplicants = this.applicants.filter(
      (applicant) => applicant.country !== 'Ghana',
    ).length;
    this.maleApplicants = this.applicants.filter(
      (applicant) => applicant.gender === 'M',
    ).length;
    this.femaleApplicants = this.applicants.filter(
      (applicant) => applicant.gender === 'F',
    ).length;

    this.totalDiplomaApplicants = this.applicants.filter(
      (applicant) => applicant.programmeType.includes('Diploma'),
    ).length;
    this.diplomaGhanaianApplicants = this.applicants.filter(
      (applicant) =>
        applicant.country === 'Ghana' && applicant.programmeType.includes('Diploma'),
    ).length;
    this.diplomaNonGhanaianApplicants = this.applicants.filter(
      (applicant) =>
        applicant.country !== 'Ghana' && applicant.programmeType.includes('Diploma'),
    ).length;
    this.diplomaMaleApplicants = this.applicants.filter(
      (applicant) =>
        applicant.gender === 'M' && applicant.programmeType.includes('Diploma'),
    ).length;
    this.diplomaFemaleApplicants = this.applicants.filter(
      (applicant) =>
        applicant.gender === 'F' && applicant.programmeType.includes('Diploma'),
    ).length;

    this.totalDegreeApplicants = this.applicants.filter(
      (applicant) => applicant.programmeType.includes('Bachelor'),
    ).length;
    this.degreeGhanaianApplicants = this.applicants.filter(
      (applicant) =>
        applicant.country === 'Ghana' && applicant.programmeType.includes('Bachelor'),
    ).length;
    this.degreeNonGhanaianApplicants = this.applicants.filter(
      (applicant) =>
        applicant.country !== 'Ghana' && applicant.programmeType.includes('Bachelor'),
    ).length;
    this.degreeMaleApplicants = this.applicants.filter(
      (applicant) =>
        applicant.gender === 'M' && applicant.programmeType.includes('Bachelor'),
    ).length;
    this.degreeFemaleApplicants = this.applicants.filter(
      (applicant) =>
        applicant.gender === 'F' && applicant.programmeType.includes('Bachelor'),
    ).length;

    this.totalCertificateApplicants = this.applicants.filter(
      (applicant) => applicant.programmeType.includes('Certificate'),
    ).length;
    this.certificateGhanaianApplicants = this.applicants.filter(
      (applicant) =>
        applicant.country === 'Ghana' &&
        applicant.programmeType.includes('Certificate'),
    ).length;
    this.certificateNonGhanaianApplicants = this.applicants.filter(
      (applicant) =>
        applicant.country !== 'Ghana' &&
        applicant.programmeType.includes('Certificate'),
    ).length;
    this.certificateMaleApplicants = this.applicants.filter(
      (applicant) =>
        applicant.gender === 'M' && applicant.programmeType.includes('Certificate'),
    ).length;
    this.certificateFemaleApplicants = this.applicants.filter(
      (applicant) =>
        applicant.gender === 'F' && applicant.programmeType.includes('Certificate'),
    ).length;

    this.acceptedApplicants = this.applicants.filter(
      (applicant) => applicant.status === 'ACCEPTED',
    ).length;
    this.acceptedGhanaianApplicants = this.applicants.filter(
      (applicant) =>
        applicant.country === 'Ghana' && applicant.status === 'ACCEPTED',
    ).length;
    this.acceptedNonGhanaianApplicants = this.applicants.filter(
      (applicant) =>
        applicant.country !== 'Ghana' && applicant.status === 'ACCEPTED',
    ).length;
    this.acceptedMaleApplicants = this.applicants.filter(
      (applicant) =>
        applicant.gender === 'M' && applicant.status === 'ACCEPTED',
    ).length;
    this.acceptedFemaleApplicants = this.applicants.filter(
      (applicant) =>
        applicant.gender === 'F' && applicant.status === 'ACCEPTED',
    ).length;

    this.waitlistedApplicants = this.applicants.filter(
      (applicant) => applicant.status === 'WAITLISTED',
    ).length;
    this.waitlistedGhanaianApplicants = this.applicants.filter(
      (applicant) =>
        applicant.country === 'Ghana' && applicant.status === 'WAITLISTED',
    ).length;
    this.waitlistedNonGhanaianApplicants = this.applicants.filter(
      (applicant) =>
        applicant.country !== 'Ghana' && applicant.status === 'WAITLISTED',
    ).length;
    this.waitlistedMaleApplicants = this.applicants.filter(
      (applicant) =>
        applicant.gender === 'M' && applicant.status === 'WAITLISTED',
    ).length;
    this.waitlistedFemaleApplicants = this.applicants.filter(
      (applicant) =>
        applicant.gender === 'F' && applicant.status === 'WAITLISTED',
    ).length;

    this.rejectedApplicants = this.applicants.filter(
      (applicant) => applicant.status === 'REJECTED',
    ).length;
    this.rejectedGhanaianApplicants = this.applicants.filter(
      (applicant) =>
        applicant.country === 'Ghana' && applicant.status === 'REJECTED',
    ).length;
    this.rejectedNonGhanaianApplicants = this.applicants.filter(
      (applicant) =>
        applicant.country !== 'Ghana' && applicant.status === 'REJECTED',
    ).length;
    this.rejectedMaleApplicants = this.applicants.filter(
      (applicant) =>
        applicant.gender === 'M' && applicant.status === 'REJECTED',
    ).length;
    this.rejectedFemaleApplicants = this.applicants.filter(
      (applicant) =>
        applicant.gender === 'F' && applicant.status === 'REJECTED',
    ).length;
  }

  fetchApplicantList(year: string) {
    console.log('Selected year: ' + year);
    this.year = year;
    this.allApplicantsService.getAllApplicants(year).subscribe((response) => {
      this.applicants = response;
      this.dataSource = this.applicants;
      this.populateApplicantsNo();
    });
  }

  downloadApplicationTypeWithGenderBasedReport(type: string, gender: string) {
    this.allApplicantExcelFileUrl =
      this.urlSignature.applicantTypeWithGenderApplicantsExcelUrl +
      this.year +
      '/' +
      gender +
      '/' +
      this.getReportType(type);

    let reportName = type + '_' + gender;
    this.reportService.downloadReport(
      this.allApplicantExcelFileUrl,
      reportName,
    );
  }

  private getReportType(type: string) {
    switch (type) {
      case 'Certificate':
        return '0';
      case 'Degree':
        return '1';
      case 'Diploma':
        return '2';
      default:
        return type;
    }
  }

  downloadGenderBasedReport(gender: string) {
    this.allApplicantExcelFileUrl =
      this.urlSignature.excelUrl + this.year + '/gender/' + gender;
    let reportName = gender;
    this.reportService.downloadReport(
      this.allApplicantExcelFileUrl,
      reportName,
    );
  }

  downloadApplicationStatusWithGenderBasedReport(type: string, gender: string) {
    this.allApplicantExcelFileUrl =
      this.urlSignature.applicantStatusWithGenderApplicantsExcelUrl +
      this.year +
      '/' +
      gender +
      '/' +
      type;
    let reportName = type + '_' + gender;
    this.reportService.downloadReport(
      this.allApplicantExcelFileUrl,
      reportName,
    );
  }

  downloadResidentBasedReport(resident: string) {
    this.allApplicantExcelFileUrl =
      this.urlSignature.applicantTypeWithResidenceApplicantsExcelUrl +
      this.year +
      '/' +
      resident +
      '/All';
    let reportName = resident;
    this.reportService.downloadReport(
      this.allApplicantExcelFileUrl,
      reportName,
    );
  }

  downloadApplicationTypeResidentBasedReport(type: string, resident: string) {
    this.allApplicantExcelFileUrl =
      this.urlSignature.applicantTypeWithResidenceApplicantsExcelUrl +
      this.year +
      '/' +
      resident +
      '/' +
      type;
    let reportName = type + '_' + resident;
    this.reportService.downloadReport(
      this.allApplicantExcelFileUrl,
      reportName,
    );
  }

  downloadApplicationStatusResidentBasedReport(type: string, resident: string) {
    this.allApplicantExcelFileUrl =
      this.urlSignature.applicantStatusWithResidenceApplicantsExcelUrl +
      this.year +
      '/' +
      resident +
      '/' +
      type;
    let reportName = type + '_' + resident;
    this.reportService.downloadReport(
      this.allApplicantExcelFileUrl,
      reportName,
    );
  }

  downloadReport(type: string) {
    switch (type) {
      case 'All':
        this.dataSource = this.applicants;
        this.allApplicantExcelFileUrl = this.urlSignature.excelUrl + this.year;
        this.reportService.downloadReport(
          this.allApplicantExcelFileUrl,
          'AllApplicants',
        );
        break;
      case 'Degree':
        this.degreeApplicants = this.applicants.filter(
          (applicant) => applicant.programmeType === 'Degree',
        );
        this.dataSource = this.degreeApplicants;
        this.degreeApplicantsExcelUrl =
          this.urlSignature.degreeApplicantsExcelUrl + this.year;
        this.reportService.downloadReport(
          this.degreeApplicantsExcelUrl,
          'DegreeApplicants',
        );
        break;
      case 'Diploma':
        this.diplomaApplicants = this.applicants.filter(
          (applicant) => applicant.programmeType === 'Diploma',
        );
        this.dataSource = this.diplomaApplicants;
        this.diplomaApplicantsExcelUrl =
          this.urlSignature.diplomaApplicantsExcelUrl + this.year;
        this.reportService.downloadReport(
          this.diplomaApplicantsExcelUrl,
          'DiplomaApplicants',
        );
        break;
      case 'Certificate':
        this.certificateApplicants = this.applicants.filter(
          (applicant) => applicant.programmeType === 'Certificate',
        );
        this.dataSource = this.certificateApplicants;
        this.certificateApplicantsExcelUrl =
          this.urlSignature.certificateApplicantsExcelUrl + this.year;
        this.reportService.downloadReport(
          this.certificateApplicantsExcelUrl,
          'CertificateApplicants',
        );
        break;
      case 'REJECTED':
        this.degreeApplicants = this.applicants.filter(
          (applicant) => applicant.status === 'REJECTED',
        );
        this.dataSource = this.degreeApplicants;
        this.rejectedApplicantsExcelUrl =
          this.urlSignature.rejectedApplicantsExcelUrl + this.year;
        this.reportService.downloadReport(
          this.rejectedApplicantsExcelUrl,
          'RejectedApplicants',
        );
        break;
      case 'ACCEPTED':
        this.diplomaApplicants = this.applicants.filter(
          (applicant) => applicant.status === 'ACCEPTED',
        );
        this.dataSource = this.diplomaApplicants;
        this.acceptedApplicantsExcelUrl =
          this.urlSignature.acceptedApplicantsExcelUrl + this.year;
        this.reportService.downloadReport(
          this.acceptedApplicantsExcelUrl,
          'AcceptedApplicants',
        );
        break;
      case 'WAITLISTED':
        this.certificateApplicants = this.applicants.filter(
          (applicant) => applicant.status === 'WAITLISTED',
        );
        this.dataSource = this.certificateApplicants;
        this.waitlistedApplicantsExcelUrl =
          this.urlSignature.waitlistedApplicantsExcelUrl + this.year;
        this.reportService.downloadReport(
          this.waitlistedApplicantsExcelUrl,
          'WaitlistedApplicants',
        );
        break;
    }
  }

  goToApplicantDetails(applicantId: string) {
    this.router.navigateByUrl(
      '/applicant?applicantId=' + applicantId + '&year=' + this.year,
    );

    console.log('goToApplicantDetails');
  }
}
